function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 倒计时
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    var swiper = new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    // 环形旋转木马
    var slideW = 370 //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
    var radius = (slideW * 0.5) / Math.sin(Math.PI / 16) //半径。圆心并不是视点中心，视点在1200px

    carouselSwiper = new Swiper('#carousel .swiper', {
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      centeredSlides: false,
      loop: true,
      loopedSlides: 4,
      grabCursor: true,
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      freeMode: true,
      speed: 4000, //匀速时间
      on: {
        progress: function (swiper, progress) {
          for (i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i)
            var slideProgress = this.slides[i].progress
            const translateX =
              (slideProgress + 1.5) *
              (slideW / 3 -
                (Math.cos((slideProgress + 1.5) * 0.125 * Math.PI) *
                  slideW *
                  1.1) /
                3) +
              'px' //调整图片间距，根据图片宽度改变数值实现自适应
            const rotateY = (slideProgress + 1.5) * 22.5 //图片角度
            const translateZ =
              radius -
              Math.cos((slideProgress + 1.5) * 0.125 * Math.PI) * radius -
              150 +
              'px' //调整图片远近，刚好4个在画框内
            slide.transform(
              'translateX(' +
              translateX +
              ') translateZ(' +
              translateZ +
              ') rotateY(' +
              rotateY +
              'deg)'
            )
          }
        },
        setTransition: function (swiper, transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i)
            slide.transition(transition)
          }
        },
      },
    })
    var swiper2 = new Swiper('.mySwiper2', {
      // loop: true, //循环滚动
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
    var swiper3 = new Swiper('.mySwiper3', {
      loop: true, //循环滚动
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
    let prods = window.product
    function getCur() {
      let color = $('#color div.active').attr('data-val')
      let type = $('#size div.active').attr('data-val')
      let qty = $('#qty div.active').attr('data-val')
      return prods.filter(item =>
        item.option1 == color
        && item.option2 == type
        && item.option3 == qty
      )[0]
    }
    function changePrice() {
      let num = $('#calcNumber').val()
      let price = ((getCur().price * num) / 100).toFixed(2)
      let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      let off_font =
        100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
      $('.font-off').html(off_font)
    }

    // 数字框
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        var newText = (num * Number(23.99)).toFixed(2)
        var oldText = (num * Number(49.99)).toFixed(2)
        changePrice()
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      var newText = (num * Number(23.99)).toFixed(2)
      var oldText = (num * Number(49.96)).toFixed(2)
      changePrice()
    })

    // 切换选项
    var imgArr = [
      // 目标商城需要展示的产品图
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/1_d6250333-3f90-426b-bfed-26008fe93ea9.png?v=1773106037',
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/2_1.png?v=1773106038',
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/3_2.png?v=1773106217',
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/1_bag.png?v=1773106038',
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/2_1_bag.png?v=1773106038',
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/3_2_bag.png?v=1773106038',

      // 用不上的产品图
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/20250923-pro-1.png',
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/20250923-pro-4.png',
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/20250923-pro-2.png',
      'https://cdn.shopify.com/s/files/1/0657/9303/2497/files/20250923-pro-3.png',
    ]
    $('#color .option').click(function () {
      var index = $(this).index()
      var index2 = $('#size .option.active').index()
      var index3 = $('#qty .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      changSwiper(index, index2, index3)
      changePrice()
    })
    $('#size .option').click(function () {
      var index = $('#color .option.active').index()
      var index2 = $(this).index()
      var index3 = $('#qty .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      changSwiper(index, index2, index3)
      changePrice()
    })

    $('#qty .option').click(function () {
      var index = $('#color .option.active').index()
      var index2 = $('#size .option.active').index()
      var index3 = $(this).index()
      $(this).addClass('active').siblings().removeClass('active')
      changSwiper(index, index2, index3)
      changePrice()
    })
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    function changSwiper(index, index2, index3) {
      //   var indexs = 0
      let indexs = index3 + index2 * 3
      // console.log("indexs",indexs)

      $("#free-tips").hide()
      if (index2 != 0) {
        $("#free-tips").show()
      }
      if (index2 == 2 && index3 == 0) {
        $('.sp-pro-img > span ').css('right', '116px')
      } else if (index2 == 1 && index3 == 1) {
        $('.sp-pro-img > span ').css('right', '295px')
      } else if (index2 == 2 && index3 == 1) {
        $('.sp-pro-img > span ').css('right', '208px')
      } else if (index2 == 1 && index3 == 0) {
        $('.sp-pro-img > span ').css('right', '273px')
      }
      $('.sp-pro-img>img').attr('src', imgArr[indexs])
    }
    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    // 加入购物车
    addCart()
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        // do something here

        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          success: function () {
            $.getJSON(
              window.Shopify.routes.root + 'cart.js',
              function (result) {
                $('#cardNum').html(result.item_count)
                if (result.item_count > 0) {
                  $('.sp-cart .num').css('background', '#cf0101')
                } else {
                  $('.sp-cart .num').css('background', '#919191')
                }
              }
            )
          },
          dataType: 'json',
        })

        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 117,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
      config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        let targetID = '#shopping'
        if ($(link).attr("ref") === "bundle") {
          targetID = '.bundle'
        }

        const targetElement = document.querySelector(targetID) // 获取跳转目标节点
        // console.log(targetElement.offsetTop, '--')
        const offsetTop =
          targetElement.offsetTop -
          $('.sp-header-top').height() -
          $('.time-part').height() + 250
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
$("#free-tips").hide()
